<template>
  <v-layout>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col col-md-6 col-xs-12">
          <div class="card jellyfish mt-5">
            <div class="card-body">
              <h4>{{ $t('login.passwordRecovery')}}</h4>
              <p class="card-text">
                {{ $t('login.passwordRecoveryText') }}
              </p>
              <form class="form" @submit.prevent="reset">
                <div class="form-group">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="fa fa-envelope fa-fw"></i>
                      </span>
                    </div>
                    <input
                      v-model="username"
                      type="email"
                      placeholder="Email"
                      class="form-control"
                    >
                  </div>
                  <small v-if="username && !validEmail" class="text-danger">
                    {{ $t('login.enterValidEmailAddress') }}
                  </small>
                </div>
                <div class="form-group">
                  <button type="submit"
                          class="btn btn-block"
                          :class="{'btn-outline-primary': !validEmail, 'btn-primary' : validEmail}"
                          :disabled="!validEmail || working || success"
                  >
                    {{ $t('login.sendPasswordResetLink') }}
                  </button>
                </div>
              </form>
              <div class="text-center">
                <div v-if="working" class="spinner-border text-primary text-center"></div>
              </div>
              <div class="alert alert-success" v-if="success">
                <h4 class="alert-heading">{{ $t('Success') }}</h4>
                <p>{{ $t('login.passwordResetSent') }}</p>
              </div>
              <div class="alert alert-danger"
                   v-if="error"
              >
                <h4 class="alert-heading">{{ $t('Error') }}</h4>
                {{ $t(error) }}
              </div>
            </div>
            <div class="card-footer">
              <router-link
                :to="{ name: 'login.index' }"
                class="card-link"
                tag="a"
              >
                {{ $t('login.back') }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
  import VLayout from '@/layouts/MinimalWithNav';

  export default {
    name: 'ForgotPasswordIndex',

    components: {
      VLayout,
    },

    data() {
      return {
        username: '',
        working: false,
        success: false,
        error: '',
      };
    },

    computed: {
      email() {
        return _.trim(_.toLower(this.username));
      },
      validEmail() {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(this.email);
      }
    },

    methods: {
      reset() {
        const self = this;
        if(self.validEmail && !self.working) {
          self.working = true;
          self.success = false;
          self.error = '';

          $.ajax({
            type: 'post',
            url: process.env.VUE_APP_API_LOCATION + '/forgot-password',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify({ email: this.email }),
          })
          .done(()=>{
            self.success = true;
          })
          .fail((jqXHR)=>{
            self.error = _.get(jqXHR, 'responseJSON.message')
          })
          .always(()=>{
            self.working = false;
          })
        }
      },
    },
  };
</script>
